import React from "react";
import { Link } from "react-router-dom";
import { Smartphone, FileText, ShieldCheck, Building2 } from "lucide-react";

/**
 * Iter37 Vague 3 — Reusable legal links card for visibility on dashboards.
 * Places "Installer / CGU / CGV / Confidentialité / Mentions légales" prominently.
 */
export default function LegalLinksCard({ compact = false }) {
  return (
    <div className="card-soft p-5" data-testid="legal-links-card">
      <h3 className="font-semibold mb-3 flex items-center gap-2" style={{ fontFamily: "Outfit" }}>
        <ShieldCheck className="w-5 h-5 text-sky-700" />
        Liens utiles & informations légales
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent("pwa:install"))}
          className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-sky-50 text-sky-700 hover:bg-sky-100 text-sm font-medium border border-sky-200 transition"
          data-testid="legal-card-install"
          title="Ajouter MySwimmingLessons à l'écran d'accueil"
        >
          <Smartphone className="w-4 h-4 shrink-0" />
          <span className="text-left leading-tight">Installer l'application</span>
        </button>
        <Link to="/legal/cgu" className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-slate-50 text-slate-700 hover:bg-slate-100 text-sm font-medium border border-slate-200 transition" data-testid="legal-card-cgu">
          <FileText className="w-4 h-4 shrink-0" /><span>CGU</span>
        </Link>
        <Link to="/legal/cgv" className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-slate-50 text-slate-700 hover:bg-slate-100 text-sm font-medium border border-slate-200 transition" data-testid="legal-card-cgv">
          <FileText className="w-4 h-4 shrink-0" /><span>CGV</span>
        </Link>
        {!compact && (
          <Link to="/legal/privacy" className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-slate-50 text-slate-700 hover:bg-slate-100 text-sm font-medium border border-slate-200 transition" data-testid="legal-card-privacy">
            <ShieldCheck className="w-4 h-4 shrink-0" /><span>Confidentialité</span>
          </Link>
        )}
        <Link to="/legal/mentions" className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-slate-50 text-slate-700 hover:bg-slate-100 text-sm font-medium border border-slate-200 transition" data-testid="legal-card-mentions">
          <Building2 className="w-4 h-4 shrink-0" /><span>Mentions légales</span>
        </Link>
        <Link to="/contact" className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-amber-50 text-amber-800 hover:bg-amber-100 text-sm font-medium border border-amber-200 transition" data-testid="legal-card-contact">
          <Building2 className="w-4 h-4 shrink-0" /><span>Nous contacter</span>
        </Link>
      </div>
    </div>
  );
}
